// import Home from '../views/home/Home.vue';
import Dummy from '@/components/dummy/Dummy';
import MapLayout from '@/templates/MapLayout';
import AboutView from '@/pages/_root/about/AboutView';

export default [
  {
    path: '/',
    name: 'Home',
    component: Dummy,
    meta: {
      title: 'Inicio',
      layout: MapLayout,
      isSlim: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView,
    meta: {
      title: 'MAPA OFICIAL DE CARRETERAS 2026',
      layout: MapLayout,
      primeIcon: 'question-circle',
      isSlim: true,
    },
  },
];
